import { render } from "./ShortTerm.vue?vue&type=template&id=8a3b6710"
import script from "./ShortTerm.vue?vue&type=script&lang=js"
export * from "./ShortTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__